export default "__VITE_ASSET__b073dfa6__"